import { SharedModule } from '../../../shared/shared.module';
import { StudentsForImpactDetailsComponent } from './students-for-impact-details.component';
import { StudentsForImpactDetailsResolver } from './students-for-impact-details.resolver';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [
    NgbModule,
    DataTableModule,
    SharedModule
  ],
  declarations: [StudentsForImpactDetailsComponent],
  exports: [StudentsForImpactDetailsComponent],
  providers: [StudentsForImpactDetailsResolver],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA]
})
export class StudentsForImpactDetailsModule {}
